import { render, staticRenderFns } from "./Step4.vue?vue&type=template&id=2f19e72e&scoped=true"
import script from "./Step4.vue?vue&type=script&lang=js"
export * from "./Step4.vue?vue&type=script&lang=js"
import style0 from "./Step4.vue?vue&type=style&index=0&id=2f19e72e&prod&lang=scss&scoped=true"
import style1 from "./Step4.vue?vue&type=style&index=1&id=2f19e72e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f19e72e",
  null
  
)

export default component.exports